"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTypography = void 0;
var defaultFontFamily = "Brutal, sans-serif";
function round(value) {
    return Math.round((value + Number.EPSILON) * 100) / 100;
}
var createTypography = function (typography) {
    if (typography === void 0) { typography = {}; }
    var _a = typography.fontFamily, fontFamily = _a === void 0 ? defaultFontFamily : _a, _b = typography.fontSize, fontSize = _b === void 0 ? 14 : _b, _c = typography.fontWeightLight, fontWeightLight = _c === void 0 ? 300 : _c, _d = typography.fontWeightRegular, fontWeightRegular = _d === void 0 ? 400 : _d, _e = typography.fontWeightMedium, fontWeightMedium = _e === void 0 ? 500 : _e, _f = typography.fontWeightBold, fontWeightBold = _f === void 0 ? 700 : _f, _g = typography.htmlFontSize, htmlFontSize = _g === void 0 ? 16 : _g;
    var coef = fontSize / 14;
    var pxToRem = function (size) { return (size / htmlFontSize) * coef + "rem"; };
    var pxToEm = function (value, fontSize) {
        return round(value / fontSize) + "em";
    };
    var body = {
        fontFamily: fontFamily,
        fontWeight: fontWeightRegular,
        fontSize: pxToRem(14),
        lineHeight: 1.43,
        letterSpacing: pxToEm(0.2, 14),
    };
    var variants = {
        h1: __assign({ fontFamily: fontFamily, fontWeight: fontWeightRegular, fontSize: pxToRem(40), lineHeight: 1.1, letterSpacing: pxToEm(-0.5, 40) }, typography.h1),
        h2: __assign({ fontFamily: fontFamily, fontWeight: fontWeightLight, fontSize: pxToRem(30), lineHeight: 1.13, letterSpacing: pxToEm(-0.5, 30) }, typography.h2),
        h3: __assign({ fontFamily: fontFamily, fontWeight: fontWeightBold, fontSize: pxToRem(18), lineHeight: 1.44, letterSpacing: pxToEm(-0.2, 18) }, typography.h3),
        h4: __assign({ fontFamily: fontFamily, fontWeight: fontWeightRegular, fontSize: pxToRem(18), lineHeight: 1.44, letterSpacing: pxToEm(-0.2, 18) }, typography.h4),
        // TODO: h5
        h5: __assign({ fontFamily: fontFamily }, typography.h5),
        // TODO: h6
        h6: __assign({ fontFamily: fontFamily }, typography.h6),
        // TODO: subtitle
        subtitle1: __assign({ fontFamily: fontFamily }, typography.subtitle1),
        // TODO: subtitle2
        subtitle2: __assign({ fontFamily: fontFamily }, typography.subtitle2),
        // `body1` and `body2` should be the same for now
        body1: __assign(__assign({}, body), typography.body1),
        body2: __assign(__assign({}, body), typography.body2),
        // CTA
        button: __assign({ fontFamily: fontFamily, fontWeight: fontWeightBold, fontSize: pxToRem(12), lineHeight: 1.33, letterSpacing: pxToEm(0.5, 12), textTransform: "uppercase" }, typography.button),
        caption: __assign({ fontFamily: fontFamily, fontWeight: fontWeightRegular, fontSize: pxToRem(12), lineHeight: 1.5 }, typography.caption),
        overline: __assign({ fontFamily: fontFamily, fontWeight: fontWeightMedium, fontSize: pxToRem(9), lineHeight: 1.66, letterSpacing: pxToEm(1, 9), textTransform: "uppercase" }, typography.overline),
    };
    return __assign({ fontSize: 14, pxToEm: pxToEm, pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontWeightLight: fontWeightLight,
        fontWeightMedium: fontWeightMedium,
        fontWeightRegular: fontWeightRegular,
        fontWeightBold: fontWeightBold }, variants);
};
exports.createTypography = createTypography;
//# sourceMappingURL=createTypography.js.map